import { Modal, Button, Icon } from "@weirgroup/weir-dls"
import { useTranslation } from "react-i18next";
import { GUEST_POPUP, StorageService } from "../../../services/storage_service";

interface Props {
    isGuestPopupShown: boolean | undefined;
}

export const GuestPopup = (props: Props) => {
    const { isGuestPopupShown } = props;
    const { t } = useTranslation();

    return (
        <div className="guest-popup">
            <Modal
                showModal={!isGuestPopupShown}
                size="small"
                canvasDeviceSize="desktop"
                dismissable={false}
                applyModalInternalGrid={true}
                modalType={"small"}
            >
                <div className="popup-container">
                    <p className="title"><Icon name={"DXPInfo"} />{t("GuestUserPopupTitle")}</p>
                    <p className="subtitle">{t("GuestUserPopupBody")}</p>
                    <div className="confirm-btn">
                        <Button
                            label={t("confirm")}
                            size={'sm'}
                            variant={'primary'}
                            onClick={() => StorageService.setItem(GUEST_POPUP, true)}
                        />
                    </div>
                </div>
            </Modal>
        </div>
    )
}